import React from 'react';

import StubForError from '@components/StubForErrors';
import { logger } from '@utils/logger';

type ErrorBoundaryState = {
  hasError: boolean;
};

type ErrorBoundaryProps = {
  children?: React.ReactNode,
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    logger.error(error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <StubForError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
